import { Injectable, ElementRef } from '@angular/core';
@Injectable()
export class AutocompleteOffService {
    /**
     * https://stackoverflow.com/questions/12374442/chrome-browser-ignoring-autocomplete-off?page=1&tab=votes#tab-top
     * @param elementRef
     */
    turnAutocompleteOff(elementRef: ElementRef) {
        const element = elementRef.nativeElement;
        if (element.hasAttribute('readonly')) {
            element.removeAttribute('readonly');
            // fix for mobile safari to show virtual keyboard
            element.blur();
            // fix firefox
            setTimeout(() => { element.focus(); }, 1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/autocomplete-off.service.ts